export const MODAL_ID = 'homepage_artwork_preview';
